var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportPrepped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Prepped"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prepped",
    clipPath: "url(#clip-Prepped)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28622",
    "data-name": "Group 28622",
    transform: "translate(7079.334 -6786.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1798",
    "data-name": "Ellipse 1798",
    d: "M6,.818A5.182,5.182,0,1,0,11.182,6,5.188,5.188,0,0,0,6,.818M6,0A6,6,0,1,1,0,6,6,6,0,0,1,6,0Z",
    transform: "translate(-7079.333 6786.987)",
    fill: "#fbac25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35794",
    "data-name": "Path 35794",
    d: "M3.022,6.043A3.022,3.022,0,1,0,0,3.022c.1-.012,3.022,0,3.022,0",
    transform: "translate(-7070.113 6796.208) rotate(180)",
    fill: "#fbac25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportPrepped);
export default __webpack_public_path__ + "static/media/Icon_ReportPrepped.d7798b31218ee6743562ea3614f76766.svg";
export { ForwardRef as ReactComponent };